import { NavMenus } from "utils/AssetsData";
import { useMemo } from "react";
import { Env } from "utils/Types";
import { AppURL } from "utils/Actions";
import AuthHelper from "components/auth/helpers";
import { useAppSelector } from "redux/hooks";

type UseFilterNavMenuProps = {
  isDisplayMenu: boolean;
};

const useFilteredNavMenus = ({ isDisplayMenu }: UseFilterNavMenuProps) => {
  const { env } = useAppSelector(state => state.globalUI);
  const userRoles = AuthHelper.getRoles();

  const filteredNavMenus = useMemo(() => {
    return NavMenus.filter(item => {
      // check environment
      if (env === Env.INTERNATIONAL && item.url === AppURL.school.easApplications) {
        return false;
      }
      // check is divider
      if (item.isDivider) {
        if (isDisplayMenu) {
          return true;
        } else {
          return false;
        }
      }

      // check roles
      const { roles: itemRestrictions } = item;
      let allowed = false;
      itemRestrictions?.forEach(ir => {
        if (userRoles.includes(ir)) {
          allowed = true;
        }
      });
      if (isDisplayMenu) {
        return allowed && item.displayInMenu;
      }
      return allowed;
    });
  }, [NavMenus, userRoles, env]);

  return { filteredNavMenus };
};

export default useFilteredNavMenus;
